import { Lock, Smartphone, Star, Image, Palette, Zap } from 'lucide-react'
import './LandingFeatures.css'

const features = [
  {
    Icon: Lock,
    title: 'Maximale Privatsphäre',
    desc: 'Kein Account, keine Weitergabe. Daten werden nach 30 Tagen automatisch gelöscht.',
  },
  {
    Icon: Smartphone,
    title: 'Original WhatsApp-Optik',
    desc: 'Sprechblasen, Farben und Layout exakt wie in WhatsApp — inklusive Emojis.',
  },
  {
    Icon: Star,
    title: 'Unbegrenzte Länge',
    desc: 'Egal ob 100 oder 100.000 Nachrichten — wir fassen alles sauber zusammen.',
  },
  {
    Icon: Image,
    title: 'Alle Medien enthalten',
    desc: 'Bilder, Videos und Audios werden als Vorschau ins PDF eingebettet.',
  },
  {
    Icon: Palette,
    title: 'Komplett anpassbar',
    desc: 'Farben, Layout und Filter live in der Vorschau einstellen — vor dem Kauf.',
  },
  {
    Icon: Zap,
    title: 'iOS & Android',
    desc: 'Funktioniert mit Exporten von WhatsApp auf iPhone und Android.',
  },
]

export function LandingFeatures() {
  return (
    <section id="funktionen" className="landing-features">
      <div className="lf-inner">
        <div className="lf-header">
          <h2 className="lf-title">Warum ChatArchiv.de?</h2>
          <p className="lf-subtitle">Die sicherste und schönste Art, deine WhatsApp-Chats zu bewahren</p>
        </div>
        <div className="lf-grid">
          {features.map(({ Icon, title, desc }, i) => (
            <div key={i} className="lf-card">
              <div className="lf-card-icon">
                <Icon size={24} />
              </div>
              <h3 className="lf-card-title">{title}</h3>
              <p className="lf-card-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
